module.exports = __webpack_public_path__ + "img/account.e60f2f32.svg";